export default __webpack_public_path__ + "static/media/IMG-20241005-WA0053.07d0b065.jpg";